<template>

    <h5>{{ getTitle(props.filter) }}</h5>
    <ControlsEvaluationFilter
        ref="controlsEvaluationFilter"
        :responsible="authenticatedUser" 
        :editing="answerChanged"
        :filter="props.filter"
        @editionModeChanged="handleAnswerChanged"
        @scopeSelected="handleScopeSelected" 
        @submitRequested="handleSubmitRequested" />
    
    <QuestionAccordion 
        ref="questionAccordion"
        @answerChanged=handleAnswerChanged />

</template>

<script setup lang="ts">

import QuestionAccordion from '@/components/dashboard/QuestionListWidget.vue';
import ControlsEvaluationFilter from '@/components/dashboard/ScopeFilterWidget.vue';
import { useLayout } from '@/layout/composables/layout';
import { ref } from 'vue';
    
    const { layoutConfig } = useLayout();
    const selectedScope = ref(null);
    const questionAccordion = ref(null);
    const controlsEvaluationFilter = ref(null);
    const authenticatedUser = localStorage.getItem('user') || null;
    const menuMode = ref(layoutConfig.menuMode);
    const answerChanged = ref(false);

    menuMode.value = 'static';

    defineExpose({
      resetScopeAndQuestions: resetScopeAndQuestions,
    });

    function getTitle(filter : string)
    {
        if (filter === 'pending-control-points') {
            return "Pontos de controle pendentes";
        } else if (filter === 'answered-control-points') {
            return "Pontos de controle respondidos";
        } else {
            return "Todos os pontos de controle";
        }
    }

    function resetScopeAndQuestions()
    {
        if (controlsEvaluationFilter.value) {
            controlsEvaluationFilter.value.resetScopeAsync();
        }
        if (questionAccordion.value) {
            questionAccordion.value.clearQuestions();
        }
    }

    const props = defineProps({
        filter : {
            type: String,
            default: 'home'
        },
    });

    const handleScopeSelected = (value) => {
        if (value === null) {
            questionAccordion.value.clearQuestions();
        }
        else {
            selectedScope.value = value;
            if (questionAccordion.value) {
                console.log("Loading questions for scope: " + value);
                questionAccordion.value.loadQuestions(value, props.filter);
            }
        }
    };

    const handleAnswerChanged = (value) => {
        answerChanged.value = value;
    };

    const handleSubmitRequested = () => {
        if (questionAccordion.value) {
            questionAccordion.value.submitAnswers();
        }
    };

</script>
